import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-newsticker-view',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './newstrickerview.component.html',
  styleUrls: ['./newstrickerview.component.scss'],
})
export class NewstrickerviewComponent {
  @Input() newsList: any[] = []; // <-- dynamic data
  @Output() addClicked = new EventEmitter();
  @Output() backtolist = new EventEmitter();

  addCreationPage() {
    this.addClicked.emit();
  }
}
